module.exports = __webpack_public_path__ + "img/btn_del_note.766eb178.svg";